import { useRange, UseRangeProps } from 'react-instantsearch';

export const RangeVirtual = (props: UseRangeProps) => {
  useRange(props);
  return null;
};
